import { useState } from 'react';
import DeletedPlantilles from '../bundles/DeletedPlantilles';

const PAGE_SIZE = 20;

function PapereraTab({ availableBundles, socket, editorExports, loading }) {
    const { castellersInfo } = editorExports;
    const [activeSubTab, setActiveSubTab] = useState('proves');
    const [provesLimit, setProvesLimit] = useState(PAGE_SIZE);

    const hiddenBundles = availableBundles
        .filter(b => b.hidden)
        .sort((a, b) => {
            const dateA = a.updatedAt || a.createdAt || '';
            const dateB = b.updatedAt || b.createdAt || '';
            return dateB.localeCompare(dateA);
        });

    return (
        <div>
            <div className="editor-subtabs">
                <button
                    className={`editor-subtab-button ${activeSubTab === 'proves' ? 'active' : ''}`}
                    onClick={() => setActiveSubTab('proves')}
                >
                    Proves eliminades
                </button>
                <button
                    className={`editor-subtab-button ${activeSubTab === 'plantilles' ? 'active' : ''}`}
                    onClick={() => setActiveSubTab('plantilles')}
                >
                    Plantilles eliminades
                </button>
            </div>

            {activeSubTab === 'proves' && (
                <div className="editor-trash-section">
                    {loading ? (
                        <div className="editor-table-container">
                            <table className="editor-table">
                                <thead>
                                    <tr>
                                        <th>Nom</th>
                                        <th>Nom curt</th>
                                        <th>Parts</th>
                                        <th>Eliminada</th>
                                        <th>Eliminat per</th>
                                        <th>Accions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.from({ length: 3 }, (_, i) => (
                                        <tr key={i} className="skeleton-row">
                                            <td><div className="skeleton-bar" style={{ width: '70%' }} /></td>
                                            <td><div className="skeleton-bar" style={{ width: '50%' }} /></td>
                                            <td><div className="skeleton-bar" style={{ width: '80%' }} /></td>
                                            <td><div className="skeleton-bar" style={{ width: '60%' }} /></td>
                                            <td><div className="skeleton-bar" style={{ width: '50%' }} /></td>
                                            <td><div className="skeleton-bar" style={{ width: '50%' }} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : hiddenBundles.length === 0 ? (
                        <div className="editor-empty-state">
                            <div className="editor-empty-state-icon">&#128465;</div>
                            <p className="editor-empty-state-text">No hi ha proves a la paperera</p>
                        </div>
                    ) : (
                        <>
                            <div className="editor-table-container">
                                <table className="editor-table">
                                    <thead>
                                        <tr>
                                            <th>Nom</th>
                                            <th>Nom curt</th>
                                            <th>Parts</th>
                                            <th>Eliminada</th>
                                            <th>Eliminat per</th>
                                            <th>Accions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {hiddenBundles.slice(0, provesLimit).map(bundle => {
                                            const user = castellersInfo?.[bundle.hiddenBy];
                                            return (
                                                <tr key={bundle.id}>
                                                    <td>{bundle.nom}</td>
                                                    <td>{bundle.shortName || '—'}</td>
                                                    <td style={{ fontSize: '0.82rem' }}>
                                                        {Object.entries(bundle.parts || {}).map(([part, plantilla]) => (
                                                            <span key={part} style={{
                                                                display: 'inline-block',
                                                                padding: '1px 6px',
                                                                marginRight: 4,
                                                                backgroundColor: '#f3f4f6',
                                                                borderRadius: 4,
                                                                fontSize: '0.78rem',
                                                            }}>
                                                                {part}: {plantilla}
                                                            </span>
                                                        ))}
                                                    </td>
                                                    <td className="editor-date-cell">
                                                        {bundle.updatedAt ? new Date(bundle.updatedAt).toLocaleDateString() : '—'}
                                                    </td>
                                                    <td>
                                                        {user ? (user.mote || user.nom) : '—'}
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap' }}>
                                                        <button
                                                            className="editor-restore-btn"
                                                            onClick={() => socket.emit('.edit_bundle', { id: bundle.id, hidden: false, hiddenBy: null })}
                                                        >
                                                            Restaurar
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {hiddenBundles.length > provesLimit && (
                                <button
                                    className="editor-load-more-btn"
                                    onClick={() => setProvesLimit(prev => prev + PAGE_SIZE)}
                                >
                                    Carregar més ({hiddenBundles.length - provesLimit} restants)
                                </button>
                            )}
                        </>
                    )}
                </div>
            )}

            {activeSubTab === 'plantilles' && (
                <div className="editor-trash-section">
                    <DeletedPlantilles {...editorExports} autoShow={true} />
                </div>
            )}
        </div>
    );
}

export default PapereraTab;
